import type { OrganizationDto } from "./OrganizationDto";
import type { CategoryDto } from "./CategoryDto";
import type { StoreDto } from "./StoreDto";
import type { TenderStageDto } from "./TenderStageDto";
import type { DocumentDto } from "./DocumentDto";

export enum TenderDetailedInfoStatus {
    "DRAFT" = "DRAFT",
    "ACCEPTANCE_PROPOSALS" = "ACCEPTANCE_PROPOSALS",
    "DOCUMENTS_ACCEPTANCE" = "DOCUMENTS_ACCEPTANCE",
    "REVIEW_PROPOSALS" = "REVIEW_PROPOSALS",
    "REBIDDING" = "REBIDDING",
    "COMPLETED" = "COMPLETED"
}
export enum TenderDetailedInfoProcessingStatus {
    "ITEMS_FILE_ERROR" = "ITEMS_FILE_ERROR",
    "ITEMS_FILE_SUCCESS" = "ITEMS_FILE_SUCCESS",
    "ITEMS_FILE_IN_PROGRESS" = "ITEMS_FILE_IN_PROGRESS"
}
export type TenderDetailedInfo = {
    /**
     * @type integer int64
    */
    id: number;
    /**
     * @type string uuid
    */
    uuid: string;
    /**
     * @type string | undefined
    */
    userComment?: string;
    /**
     * @type string
    */
    status: TenderDetailedInfoStatus;
    /**
     * @type string | undefined
    */
    name?: string;
    /**
     * @type string | undefined
    */
    information?: string;
    /**
     * @type string | undefined
    */
    processingStatus?: TenderDetailedInfoProcessingStatus;
    ownerOrganization: OrganizationDto;
    category: CategoryDto;
    store?: StoreDto;
    stage?: TenderStageDto;
    /**
     * @type array | undefined
    */
    documents?: DocumentDto[];
};
